import axios from '../axios'
import constants from '../constants'

const errMsg = 'Server is unavailable.'

export const getUserList = (start, limit, order, search, startDate, endDate, sortBy, isExport = false,type,token) => (dispatch) => {
  axios.get(`/admin/users?start=${start}&limit=${limit}&sort=${sortBy}&order=${order}&search=${search}&sd=${startDate}&ed=${endDate}&eType=${type}`, { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.USER_LIST,
      payload: {
        data: response.data.data ? response.data.data : {},
        resStatus: true
      }
    })
  }).catch(() => {
    dispatch({
      type: constants.USER_LIST,
      payload: {
        data: {},
        resStatus: false
      }
    })
  })
}

export const addAdminUser = (sEmail, sMobNum, sPassword, token) => (dispatch) => {
  axios.post(`/admin/users/create-organizer`,{sEmail, sMobNum, sPassword}, { headers: {Authorization:token} }).then((response) => {
    dispatch({
      type: constants.ADD_ADMIN_USER,
      payload: {
        data: response.data.data,
        resStatus: true,
        resMessage: response.data.message
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.ADD_ADMIN_USER,
      payload: {
        data: {},
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}

export const updateUser = (updateUserData, token, ID) => async(dispatch) => {
  const {eStatus} = updateUserData
  // dispatch({ type: CLEAR})
  await axios.put(`/admin/users/${ID}`, {
    eStatus: eStatus,
  }, { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.UPDATE_USER,
      payload: {
        data: response.data.data ? response.data.data : [],
        resStatus: true,
        resMessage: response.data.message
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.UPDATE_USER,
      payload: {
        data: {},
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}

export const clearUserExportData = () => ({
  type: constants.CLEAR_USER_EXPORT_DATA
})
